import React, { ReactElement } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import FlexContainer from '../flex-container/flex-container.component';
import FormatService from '../../services/format-service';
import useStylesLoader from './loader.styles';

const Loader: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COLOR_SECONDARY: ThemeColor = 'secondary';

  const {
    isInline,
    isFloating,
    isSubmit,
    isModal,
    isSmall,
    isHidden,
    isPageLoader,
    withTopOffset,
    className,
    top,
    left,
  } = props;

  const { classes } = useStylesLoader();

  const inlineClassName: string | undefined = isInline ? classes.loaderInline : undefined;
  const floatingClassName: string | undefined = isFloating ? classes.loaderFloating : undefined;
  const submitClassName: string | undefined = isSubmit ? classes.loaderSubmit : undefined;
  const modalClassName: string | undefined = isModal ? classes.loaderModal : undefined;
  const modalSubmitClassName: string | undefined = isModal && isSubmit ? classes.loaderModalSubmit : undefined;
  const pageClassName: string | undefined = isPageLoader ? classes.loaderPage : undefined;
  const pageTopOffsetClassName: string | undefined = isPageLoader && withTopOffset
    ? classes.loaderPageTopOffset : undefined;
  const hiddenClassName: string | undefined = isHidden ? classes.loaderHidden : undefined;
  const progressSmallClassName: string | undefined = isSmall ? classes.loaderProgressSmall : undefined;

  return (
    <FlexContainer
      isCentered
      isInline={isSubmit || isModal}
      className={FormatService.formatClassNames(
        classes.loader, inlineClassName, floatingClassName, submitClassName, modalClassName,
        modalSubmitClassName, pageClassName, pageTopOffsetClassName, hiddenClassName, className,
      )}
      style={{
        marginTop: top || undefined,
        marginLeft: left || undefined,
      }}
    >
      <CircularProgress
        color={COLOR_SECONDARY}
        className={FormatService.formatClassNames(classes.loaderProgress, progressSmallClassName)}
      />
    </FlexContainer>
  );
});

export default Loader;
